// Dummy data for Review Mappings Modal
// Contains standard headers from uploaded files and sample values for each header

// Formula functions available for auto-suggest
export const FORMULA_FUNCTIONS = [
  {
    name: "FILENAME",
    description: "Name of the current file",
    syntax: "FILENAME()",
  },
  {
    name: "SHEETNAME",
    description: "Name of the current sheet",
    syntax: "SHEETNAME()",
  },
  {
    name: "CONCAT",
    description: "Concatenate values",
    syntax: "CONCAT(value1, value2, ...)",
  },
  {
    name: "TRIM",
    description: "Remove leading/trailing spaces",
    syntax: "TRIM(text)",
  },
  {
    name: "IF",
    description: "Conditional logic",
    syntax: "IF(condition, true_value, false_value)",
  },
  {
    name: "LEFT",
    description: "Extract left characters",
    syntax: "LEFT(text, num_chars)",
  },
  {
    name: "RIGHT",
    description: "Extract right characters",
    syntax: "RIGHT(text, num_chars)",
  },
  {
    name: "MID",
    description: "Extract middle characters",
    syntax: "MID(text, start, num_chars)",
  },
  { name: "LEN", description: "Get text length", syntax: "LEN(text)" },
  { name: "UPPER", description: "Convert to uppercase", syntax: "UPPER(text)" },
  { name: "LOWER", description: "Convert to lowercase", syntax: "LOWER(text)" },
  {
    name: "DATE_FORMAT",
    description: "Format date",
    syntax: "DATE_FORMAT(date, format)",
  },
  {
    name: "SUM",
    description: "Sum of values",
    syntax: "SUM(value1, value2, ...)",
  },
  { name: "ABS", description: "Absolute value", syntax: "ABS(number)" },
  {
    name: "ROUND",
    description: "Round number",
    syntax: "ROUND(number, decimals)",
  },
  {
    name: "REPLACE",
    description: "Replace text",
    syntax: "REPLACE(text, old_text, new_text)",
  },
  {
    name: "SUBSTITUTE",
    description: "Substitute text",
    syntax: "SUBSTITUTE(text, old_text, new_text)",
  },
  {
    name: "TEXT",
    description: "Format as text",
    syntax: "TEXT(value, format)",
  },
  { name: "VALUE", description: "Convert to number", syntax: "VALUE(text)" },
  {
    name: "ISNULL",
    description: "Check if null",
    syntax: "ISNULL(value, default)",
  },
  {
    name: "COALESCE",
    description: "First non-null value",
    syntax: "COALESCE(value1, value2, ...)",
  },
  {
    name: "GT",
    description: "Greater than comparison",
    syntax: "GT(value1, value2)",
  },
  {
    name: "GTE",
    description: "Greater than or equal",
    syntax: "GTE(value1, value2)",
  },
  {
    name: "LT",
    description: "Less than comparison",
    syntax: "LT(value1, value2)",
  },
  {
    name: "LTE",
    description: "Less than or equal",
    syntax: "LTE(value1, value2)",
  },
  {
    name: "EQ",
    description: "Equal comparison",
    syntax: "EQ(value1, value2)",
  },
  {
    name: "NEQ",
    description: "Not equal comparison",
    syntax: "NEQ(value1, value2)",
  },
  {
    name: "MIN",
    description: "Minimum value",
    syntax: "MIN(value1, value2, ...)",
  },
  {
    name: "MAX",
    description: "Maximum value",
    syntax: "MAX(value1, value2, ...)",
  },
  {
    name: "EUROPEAN_AMOUNT",
    description: "Format number in European style (1.234,56)",
    syntax: "EUROPEAN_AMOUNT(number, decimals)",
  },
  {
    name: "EUROPEAN_DATE",
    description: "Format date in European style (DD/MM/YYYY)",
    syntax: "EUROPEAN_DATE(date)",
  },
  {
    name: "EUROPEAN_TIME",
    description: "Format time in 24-hour European style (HH:mm)",
    syntax: "EUROPEAN_TIME(time)",
  },
  {
    name: "EUROPEAN_CURRENCY",
    description: "Format currency in European style (1.234,56 €)",
    syntax: "EUROPEAN_CURRENCY(number, symbol, decimals)",
  },
  {
    name: "USD_FORMAT",
    description: "Convert European format number (1.234,56) to USD format (1,234.56)",
    syntax: "USD_AMOUNT(european_number, decimals)",
  },
  {
    name: "ADD",
    description: "Add two or more numbers",
    syntax: "ADD(number1, number2, ...)",
  },
  {
    name: "SUBTRACT",
    description: "Subtract numbers",
    syntax: "SUBTRACT(number1, number2)",
  },
  {
    name: "MULTIPLY",
    description: "Multiply numbers",
    syntax: "MULTIPLY(number1, number2, ...)",
  },
  {
    name: "DIVIDE",
    description: "Divide numbers",
    syntax: "DIVIDE(dividend, divisor)",
  },
  { name: "YEAR", description: "Extract year from date", syntax: "YEAR(date)" },
  {
    name: "MONTH",
    description: "Extract month from date",
    syntax: "MONTH(date)",
  },
  { name: "DAY", description: "Extract day from date", syntax: "DAY(date)" },
];

// Sample client headers that would be extracted from uploaded Excel files
// These headers are common across all file types
const CLIENT_HEADERS = [
  "JE Number",
  "GL Account Number",
  "Functional Amount",
  "Effective date",
  "Period",
  "Entry date",
  "Functional Currency Code",
  "Business Unit",
  "Source",
  "Preparer ID",
  "JE Line Number",
  "JE Description",
  "JE Line Description",
  "Year",
  "delimiter count",
];

export const SAMPLE_CLIENT_HEADERS = {
  "Journal Entry (JE)": CLIENT_HEADERS,
  "Trial Balance (TB)": CLIENT_HEADERS,
  "Chart of Accounts (COA)": CLIENT_HEADERS,
};

// Sample values for each client header (used for preview/formula testing)
export const SAMPLE_VALUES = {
  "JE Number": "JE-2025-001234",
  "GL Account Number": "10100-001",
  "Functional Amount": 15000.0,
  "Effective date": "2025-03-15",
  Period: "03",
  "Entry date": "2025-03-14",
  "Functional Currency Code": "USD",
  "Business Unit": "Corporate",
  Source: "SAP",
  "Preparer ID": "JSMITH",
  "JE Line Number": "1",
  "JE Description": "Month End Accrual",
  "JE Line Description": "Accrued Expenses",
  Year: "2025",
  "delimiter count": "5",
};

// Dummy files data with headers extracted from files and mappings


// Get sample value for a header
export const getSampleValue = (header) => {
  return SAMPLE_VALUES[header] || `Sample_${header}`;
};

// Get available headers for a file type
export const getAvailableHeaders = (fileType) => {
  return SAMPLE_CLIENT_HEADERS[fileType] || [];
};

// Get dummy files for a file type
// export const getDummyFilesForType = (fileType) => {
//   return DUMMY_FILES_DATA[fileType] || [];
// };

// Helper function to detect if a string looks like a date
const isDateLike = (str) => {
  if (typeof str !== "string") return false;
  // Common date patterns
  const datePatterns = [
    /^\d{4}[-/]\d{1,2}[-/]\d{1,2}/, // ISO: 2025-03-15, 2025/03/15
    /^\d{1,2}[-/]\d{1,2}[-/]\d{4}/, // US/EU: 03/15/2025, 15-03-2025
    /^\d{1,2}[-/]\d{1,2}[-/]\d{2}$/, // Short year: 03/15/25
    /^\d{8}$/, // YYYYMMDD: 20250315
  ];
  return datePatterns.some((pattern) => pattern.test(str.trim()));
};

// Robust date parser that handles multiple formats
const parseDate = (dateValue) => {
  if (!dateValue) return null;

  // If already a Date object
  if (dateValue instanceof Date) {
    return isNaN(dateValue.getTime()) ? null : dateValue;
  }

  // If it's a number (Excel serial date or timestamp)
  if (typeof dateValue === "number") {
    // Excel serial date (days since 1900-01-01, with Excel's leap year bug)
    if (dateValue > 0 && dateValue < 100000) {
      // Excel serial date
      const excelEpoch = new Date(1899, 11, 30); // Dec 30, 1899
      const date = new Date(excelEpoch.getTime() + dateValue * 86400000);
      return isNaN(date.getTime()) ? null : date;
    }
    // Unix timestamp in milliseconds
    const date = new Date(dateValue);
    return isNaN(date.getTime()) ? null : date;
  }

  const str = String(dateValue).trim();

  // Try ISO format first (YYYY-MM-DD or YYYY/MM/DD)
  const isoMatch = str.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return isNaN(date.getTime()) ? null : date;
  }

  // YYYYMMDD format
  const compactMatch = str.match(/^(\d{4})(\d{2})(\d{2})$/);
  if (compactMatch) {
    const [, year, month, day] = compactMatch;
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return isNaN(date.getTime()) ? null : date;
  }

  // US format (MM/DD/YYYY or MM-DD-YYYY)
  const usMatch = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (usMatch) {
    const [, month, day, year] = usMatch;
    // Check if it could be EU format (day > 12)
    if (parseInt(month) <= 12) {
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      return isNaN(date.getTime()) ? null : date;
    }
  }

  // EU format (DD/MM/YYYY or DD-MM-YYYY) - when first number > 12
  const euMatch = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (euMatch) {
    const [, day, month, year] = euMatch;
    if (parseInt(day) > 12 && parseInt(month) <= 12) {
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      return isNaN(date.getTime()) ? null : date;
    }
  }

  // Short year format (MM/DD/YY or DD/MM/YY)
  const shortYearMatch = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{2})$/);
  if (shortYearMatch) {
    const [, first, second, shortYear] = shortYearMatch;
    const year = parseInt(shortYear) + (parseInt(shortYear) > 50 ? 1900 : 2000);
    const date = new Date(year, parseInt(first) - 1, parseInt(second));
    return isNaN(date.getTime()) ? null : date;
  }

  // Fallback to native Date parsing
  const date = new Date(str);
  return isNaN(date.getTime()) ? null : date;
};

// Formula function implementations
const formulaFunctions = {
  // String functions
  CONCAT: (...args) => args.join(""),
  TRIM: (text) => String(text ?? "").trim(),
  LEFT: (text, numChars) =>
    String(text ?? "").substring(0, parseInt(numChars) || 0),
  RIGHT: (text, numChars) => {
    const str = String(text ?? "");
    const n = parseInt(numChars) || 0;
    return str.substring(str.length - n);
  },
  MID: (text, start, numChars) => {
    const str = String(text ?? "");
    const startIdx = Math.max(0, (parseInt(start) || 1) - 1); // Excel MID is 1-based
    const len = parseInt(numChars) || 0;
    return str.substring(startIdx, startIdx + len);
  },
  LEN: (text) => String(text ?? "").length,
  UPPER: (text) => String(text ?? "").toUpperCase(),
  LOWER: (text) => String(text ?? "").toLowerCase(),
  // REPLACE: (text, oldText, newText) =>
  //   String(text ?? "").replace(oldText, newText),
  SUBSTITUTE: (text, oldText, newText) =>
    String(text ?? "")
      .split(oldText)
      .join(newText),

  // Conditional functions
  IF: (condition, trueValue, falseValue) => {
    // If condition is already a boolean, use it directly
    if (typeof condition === "boolean") {
      return condition ? trueValue : falseValue;
    }

    // If condition is a number, treat 0 as false, non-zero as true
    if (typeof condition === "number") {
      return condition !== 0 ? trueValue : falseValue;
    }

    // Handle comparison operators in condition string
    if (typeof condition === "string") {
      const trimmedCondition = condition.trim();
      
      // Check for empty string (falsy)
      if (trimmedCondition === "") {
        return falseValue;
      }

      // Parse comparison expressions like "A>B", "A=B", "A<>B"
      const comparisonMatch = trimmedCondition.match(/^(.+?)(>=|<=|<>|!=|>|<|=)(.+)$/);
      if (comparisonMatch) {
        const [, leftRaw, operator, rightRaw] = comparisonMatch;
        const left = leftRaw.trim();
        const right = rightRaw.trim();
        
        // Helper to parse value - could be number, date, or string
        const parseValue = (val) => {
          // Remove quotes if present
          if ((val.startsWith('"') && val.endsWith('"')) || 
              (val.startsWith("'") && val.endsWith("'"))) {
            return { type: 'string', value: val.slice(1, -1) };
          }
          
          // Check if it's a number
          const num = parseFloat(val);
          if (!isNaN(num) && isFinite(num)) {
            return { type: 'number', value: num };
          }
          
          // Check if it's a date-like value
          const datePatterns = [
            /^\d{4}[-/]\d{1,2}[-/]\d{1,2}/, // ISO: 2025-03-15
            /^\d{1,2}[-/]\d{1,2}[-/]\d{4}/, // US/EU: 03/15/2025
            /^\d{8}$/, // YYYYMMDD
          ];
          
          if (datePatterns.some(pattern => pattern.test(val))) {
            const date = parseDate(val);
            if (date) {
              return { type: 'date', value: date.getTime() };
            }
          }
          
          // Default to string comparison
          return { type: 'string', value: val };
        };
        
        const leftParsed = parseValue(left);
        const rightParsed = parseValue(right);
        
        // If both are same type, compare directly
        // If types differ, try to coerce to the more specific type
        let leftVal, rightVal;
        
        if (leftParsed.type === 'date' || rightParsed.type === 'date') {
          // Date comparison - try to parse both as dates
          const leftDate = parseDate(left);
          const rightDate = parseDate(right);
          if (leftDate && rightDate) {
            leftVal = leftDate.getTime();
            rightVal = rightDate.getTime();
          } else {
            // Fallback to string comparison
            leftVal = left;
            rightVal = right;
          }
        } else if (leftParsed.type === 'number' && rightParsed.type === 'number') {
          // Both are numbers
          leftVal = leftParsed.value;
          rightVal = rightParsed.value;
        } else if (leftParsed.type === 'number' || rightParsed.type === 'number') {
          // One is number, try to compare as numbers
          const leftNum = parseFloat(left);
          const rightNum = parseFloat(right);
          if (!isNaN(leftNum) && !isNaN(rightNum)) {
            leftVal = leftNum;
            rightVal = rightNum;
          } else {
            // Fallback to string comparison
            leftVal = String(left);
            rightVal = String(right);
          }
        } else {
          // String comparison
          leftVal = String(leftParsed.value);
          rightVal = String(rightParsed.value);
        }
        
        let result;
        switch (operator) {
          case ">":
            result = leftVal > rightVal;
            break;
          case "<":
            result = leftVal < rightVal;
            break;
          case ">=":
            result = leftVal >= rightVal;
            break;
          case "<=":
            result = leftVal <= rightVal;
            break;
          case "=":
            result = leftVal === rightVal;
            break;
          case "<>":
          case "!=":
            result = leftVal !== rightVal;
            break;
          default:
            result = false;
        }
        return result ? trueValue : falseValue;
      }
      
      // No comparison operator found - treat non-empty string as truthy
      // unless it's "false", "0", "null", "undefined"
      const lowerCondition = trimmedCondition.toLowerCase();
      if (lowerCondition === "false" || lowerCondition === "0" || 
          lowerCondition === "null" || lowerCondition === "undefined") {
        return falseValue;
      }
      return trueValue;
    }

    // For any other type, use JavaScript truthiness
    return condition ? trueValue : falseValue;
  },
  ISNULL: (value, defaultValue) =>
    value === null || value === undefined || value === ""
      ? defaultValue
      : value,
  COALESCE: (...args) =>
    args.find((arg) => arg !== null && arg !== undefined && arg !== "") ?? null,

  // Comparison functions
  GT: (a, b) => (parseFloat(a) || 0) > (parseFloat(b) || 0),
  GTE: (a, b) => (parseFloat(a) || 0) >= (parseFloat(b) || 0),
  LT: (a, b) => (parseFloat(a) || 0) < (parseFloat(b) || 0),
  LTE: (a, b) => (parseFloat(a) || 0) <= (parseFloat(b) || 0),
  EQ: (a, b) => {
    const numA = parseFloat(a);
    const numB = parseFloat(b);
    if (!isNaN(numA) && !isNaN(numB)) return numA === numB;
    return String(a).trim() === String(b).trim();
  },
  NEQ: (a, b) => {
    const numA = parseFloat(a);
    const numB = parseFloat(b);
    if (!isNaN(numA) && !isNaN(numB)) return numA !== numB;
    return String(a).trim() !== String(b).trim();
  },
  // MIN and MAX functions
  MIN: (...args) => Math.min(...args.map(v => parseFloat(v) || 0)),
  MAX: (...args) => Math.max(...args.map(v => parseFloat(v) || 0)),

  // European number format: 1.234,56 (dot for thousands, comma for decimals)
  EUROPEAN_AMOUNT: (number, decimals = 2) => {
    const num = parseFloat(number);
    if (isNaN(num)) return "";
    const dec = parseInt(decimals) || 2;
    
    // Split into integer and decimal parts
    const fixed = Math.abs(num).toFixed(dec);
    const [intPart, decPart] = fixed.split('.');
    
    // Add thousand separators (dots) to integer part
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    // Combine with comma as decimal separator
    const formatted = decPart ? `${withThousands},${decPart}` : withThousands;
    
    // Add negative sign if needed
    return num < 0 ? `-${formatted}` : formatted;
  },

  // European date format: DD/MM/YYYY
  EUROPEAN_DATE: (dateValue) => {
    const date = parseDate(dateValue);
    if (!date) return "";
    
    const pad = (n) => n.toString().padStart(2, "0");
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  },

  // European time format: 24-hour (HH:mm)
  EUROPEAN_TIME: (timeValue) => {
    // Handle Date object
    if (timeValue instanceof Date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${pad(timeValue.getHours())}:${pad(timeValue.getMinutes())}`;
    }
    
    // Handle string time formats
    const str = String(timeValue ?? "").trim();
    
    // Try to parse various time formats
    // HH:mm:ss or HH:mm format
    const timeMatch = str.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\s*(AM|PM))?$/i);
    if (timeMatch) {
      let hours = parseInt(timeMatch[1]);
      const minutes = timeMatch[2];
      const ampm = timeMatch[4];
      
      // Convert 12-hour to 24-hour if AM/PM present
      if (ampm) {
        if (ampm.toUpperCase() === 'PM' && hours !== 12) {
          hours += 12;
        } else if (ampm.toUpperCase() === 'AM' && hours === 12) {
          hours = 0;
        }
      }
      
      return `${hours.toString().padStart(2, "0")}:${minutes}`;
    }
    
    // Try parsing as date-time
    const date = parseDate(timeValue);
    if (date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    }
    
    return "";
  },

  // European currency format: 1.234,56 € (symbol after number with space)
  EUROPEAN_CURRENCY: (number, symbol = "€", decimals = 2) => {
    const num = parseFloat(number);
    if (isNaN(num)) return "";
    const dec = parseInt(decimals) || 2;
    const currencySymbol = String(symbol || "€").trim();
    
    // Split into integer and decimal parts
    const fixed = Math.abs(num).toFixed(dec);
    const [intPart, decPart] = fixed.split('.');
    
    // Add thousand separators (dots) to integer part
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    // Combine with comma as decimal separator
    const formatted = decPart ? `${withThousands},${decPart}` : withThousands;
    
    // Add negative sign if needed and currency symbol after with space
    const signedNumber = num < 0 ? `-${formatted}` : formatted;
    return `${signedNumber} ${currencySymbol}`;
  },

  // Convert European format (1.234,56) to USD format (1,234.56)
  USD_FORMAT: (europeanNumber, decimals = 2) => {
    // Handle if already a number
    if (typeof europeanNumber === 'number') {
      const dec = parseInt(decimals) || 2;
      return europeanNumber.toLocaleString('en-US', {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec,
      });
    }
    
    const str = String(europeanNumber ?? "").trim();
    if (!str) return "";
    
    // Check if it's already in US format (has comma before period or no European markers)
    // European format uses: dots for thousands, comma for decimals
    // US format uses: commas for thousands, period for decimals
    
    // Remove any currency symbols and spaces
    let cleaned = str.replace(/[€$£¥\s]/g, '').trim();
    
    // Handle negative numbers
    const isNegative = cleaned.startsWith('-');
    if (isNegative) cleaned = cleaned.substring(1);
    
    // European format: 1.234,56 or 1.234.567,89
    // Check if it has comma as decimal separator (European style)
    const hasEuropeanDecimal = /,\d{1,2}$/.test(cleaned);
    const hasEuropeanThousands = /\.\d{3}/.test(cleaned);
    
    let numericValue;
    
    if (hasEuropeanDecimal || hasEuropeanThousands) {
      // It's European format - convert to number
      // Remove thousand separators (dots) and replace decimal comma with period
      const normalized = cleaned
        .replace(/\./g, '')  // Remove thousand separators (dots)
        .replace(',', '.');   // Replace decimal comma with period
      numericValue = parseFloat(normalized);
    } else {
      // Assume it's already a plain number or US format
      const normalized = cleaned.replace(/,/g, ''); // Remove any commas
      numericValue = parseFloat(normalized);
    }
    
    if (isNaN(numericValue)) return "";
    if (isNegative) numericValue = -numericValue;
    
    const dec = parseInt(decimals) || 2;
    
    // Format in US style with commas as thousand separators and period as decimal
    return numericValue.toLocaleString('en-US', {
      minimumFractionDigits: dec,
      maximumFractionDigits: dec,
    });
  },

  // Numeric functions
  SUM: (...args) => args.reduce((sum, val) => sum + (parseFloat(val) || 0), 0),
  ABS: (number) => Math.abs(parseFloat(number) || 0),
  ROUND: (number, decimals = 0) => {
    const num = parseFloat(number) || 0;
    const dec = parseInt(decimals) || 0;
    return Number(num.toFixed(dec));
  },
  VALUE: (text) => parseFloat(text) || 0,

  // Mathematical operations
  ADD: (...args) => args.reduce((sum, val) => sum + (parseFloat(val) || 0), 0),
  SUBTRACT: (num1, num2) => (parseFloat(num1) || 0) - (parseFloat(num2) || 0),
  MULTIPLY: (...args) =>
    args.reduce((product, val) => product * (parseFloat(val) || 0), 1),
  DIVIDE: (dividend, divisor) => {
    const div = parseFloat(divisor) || 0;
    if (div === 0) return "";
    return (parseFloat(dividend) || 0) / div;
  },

  // Date extraction functions
  YEAR: (dateValue) => {
    const date = parseDate(dateValue);
    if (!date) return "";
    return date.getFullYear();
  },
  MONTH: (dateValue) => {
    const date = parseDate(dateValue);
    if (!date) return "";
    return date.getMonth() + 1; // JavaScript months are 0-based, Excel is 1-based
  },
  DAY: (dateValue) => {
    const date = parseDate(dateValue);
    if (!date) return "";
    return date.getDate();
  },

  // Date/Text formatting functions
  TEXT: (value, format) => {
    // If no format provided, return value as string
    if (!format) return String(value);
    
    // Check for date-like values FIRST before number check
    // This prevents "2024-03-31" from being parsed as number 2024
    if (isDateLike(String(value))) {
      const date = parseDate(value);
      if (date) {
        const pad = (n) => n.toString().padStart(2, "0");
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        if (format === "YYYY-MM-DD" || format === "yyyy-mm-dd")
          return `${year}-${month}-${day}`;
        if (format === "MM/DD/YYYY" || format === "mm/dd/yyyy")
          return `${month}/${day}/${year}`;
        if (format === "DD/MM/YYYY" || format === "dd/mm/yyyy")
          return `${day}/${month}/${year}`;
        if (format === "DD-MM-YYYY" || format === "dd-mm-yyyy")
          return `${day}-${month}-${year}`;
        if (format === "YYYY/MM/DD" || format === "yyyy/mm/dd")
          return `${year}/${month}/${day}`;
        if (format === "YYYYMMDD" || format === "yyyymmdd")
          return `${year}${month}${day}`;
        if (format === "MMMM" || format === "mmmm")
          return date.toLocaleString("en-US", { month: "long" });
        if (format === "MMM" || format === "mmm")
          return date.toLocaleString("en-US", { month: "short" });
        if (format === "DDDD" || format === "dddd")
          return date.toLocaleString("en-US", { weekday: "long" });
        if (format === "DDD" || format === "ddd")
          return date.toLocaleString("en-US", { weekday: "short" });
        if (format === "MM-YYYY" || format === "mm-yyyy")
          return `${month}-${year}`;
        if (format === "YYYY" || format === "yyyy")
          return `${year}`;
        if (format === "MM" || format === "mm")
          return `${month}`;
        if (format === "DD" || format === "dd")
          return `${day}`;
        if (format === "DD-MM" || format === "dd-mm")
          return `${day}-${month}`;
        if (format === "YY/MM" || format === "yy/mm")
          return `${year.toString().slice(-2)}/${month}`;
        if (format === "DD/MM" || format === "dd/mm")
          return `${day}/${month}`;
        if (format === "MM/DD" || format === "mm/dd")      
          return `${month}/${day}`;

        // Format not recognized for date value, return empty string
        return "";
      }
    }
    
    // Handle number formatting
    if (!isNaN(parseFloat(value))) {
      const num = parseFloat(value);
      // Common format patterns
      if (format === "0" || format === "#") return Math.round(num).toString();
      if (format === "0.00" || format === "#.##") return num.toFixed(2);
      if (format === "0.0" || format === "#.#") return num.toFixed(1);
      if (format === "0%" || format === "#%")
        return (num * 100).toFixed(0) + "%";
      if (format === "0.00%" || format === "#.##%")
        return (num * 100).toFixed(2) + "%";
      // Currency formats
      if (format === "$#,##0.00" || format === "$0.00")
        return "$" + num.toFixed(2);
      if (format === "$#,##0" || format === "$0")
        return "$" + Math.round(num).toLocaleString("en-US");
      // Thousand separators
      if (format === "#,##0" || format === "#,###")
        return num.toLocaleString("en-US", { maximumFractionDigits: 0 });
      if (format === "#,##0.00")
        return num.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      // General number format - try to apply custom decimal places from format
      const decimalMatch = format.match(/0\.(0+)/);
      if (decimalMatch) {
        return num.toFixed(decimalMatch[1].length);
      }
      // Format not recognized for number, return empty string
      return "";
    }
    // Handle date formatting (fallback for non-date-like strings that can still be parsed)
    const date = parseDate(value);
    if (date) {
      const pad = (n) => n.toString().padStart(2, "0");
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      if (format === "YYYY-MM-DD" || format === "yyyy-mm-dd")
        return `${year}-${month}-${day}`;
      if (format === "MM/DD/YYYY" || format === "mm/dd/yyyy")
        return `${month}/${day}/${year}`;
      if (format === "DD/MM/YYYY" || format === "dd/mm/yyyy")
        return `${day}/${month}/${year}`;
      if (format === "DD-MM-YYYY" || format === "dd-mm-yyyy")
        return `${day}-${month}-${year}`;
      if (format === "YYYY/MM/DD" || format === "yyyy/mm/dd")
        return `${year}/${month}/${day}`;
      if (format === "YYYYMMDD" || format === "yyyymmdd")
        return `${year}${month}${day}`;
      if (format === "MMMM" || format === "mmmm")
        return date.toLocaleString("en-US", { month: "long" });
      if (format === "MMM" || format === "mmm")
        return date.toLocaleString("en-US", { month: "short" });
      if (format === "DDDD" || format === "dddd")
        return date.toLocaleString("en-US", { weekday: "long" });
      if (format === "DDD" || format === "ddd")
        return date.toLocaleString("en-US", { weekday: "short" });
      // Format not recognized for date, return empty string
      return "";
    }
    // Return empty string for non-number and non-date values with unrecognized format
    return "";
  },
  DATE_FORMAT: (date, format) => formulaFunctions.TEXT(date, format),
};

// Parse and evaluate function calls recursively
// @param funcName - name of the function to call
// @param argsString - comma-separated arguments string
// @param valueSource - object with header values (defaults to SAMPLE_VALUES)
const evaluateFunctionCall = (funcName, argsString, valueSource = SAMPLE_VALUES) => {
  const fn = formulaFunctions[funcName.toUpperCase()];
  if (!fn) {
    throw new Error(`Unknown function: ${funcName}`);
  }

  // Parse arguments, handling nested function calls
  const args = parseArguments(argsString, valueSource);
  return fn(...args);
};

// Parse comma-separated arguments, respecting nested parentheses and quotes
// @param argsString - comma-separated arguments string
// @param valueSource - object with header values (defaults to SAMPLE_VALUES)
const parseArguments = (argsString, valueSource = SAMPLE_VALUES) => {
  const args = [];
  let current = "";
  let depth = 0;
  let inQuotes = false;
  let quoteChar = "";

  for (let i = 0; i < argsString.length; i++) {
    const char = argsString[i];

    if (
      (char === '"' || char === "'") &&
      (i === 0 || argsString[i - 1] !== "\\")
    ) {
      if (!inQuotes) {
        inQuotes = true;
        quoteChar = char;
      } else if (char === quoteChar) {
        inQuotes = false;
      }
      current += char;
    } else if (char === "(" && !inQuotes) {
      depth++;
      current += char;
    } else if (char === ")" && !inQuotes) {
      depth--;
      current += char;
    } else if (char === "," && depth === 0 && !inQuotes) {
      args.push(evaluateExpression(current.trim(), valueSource));
      current = "";
    } else {
      current += char;
    }
  }

  if (current.trim()) {
    args.push(evaluateExpression(current.trim(), valueSource));
  }

  return args;
};

// Evaluate a single expression (could be a function, header reference, string, or number)
// @param expr - the expression to evaluate
// @param valueSource - object with header values (defaults to SAMPLE_VALUES)
const evaluateExpression = (expr, valueSource = SAMPLE_VALUES) => {
  if (!expr) return "";

  // First, replace all header references [Header Name] with their values
  const headerPattern = /\[([^\]]+)\]/g;
  let processedExpr = String(expr);
  let match;
  let hasHeaders = false;

  while ((match = headerPattern.exec(expr)) !== null) {
    hasHeaders = true;
    const header = match[1];
    const value = valueSource[header] ?? "";
    processedExpr = processedExpr.replace(`[${header}]`, value);
  }

  // Function calls must be matched before comparisons, or IF(a>b, x, y) is split on its inner operator
  const funcPattern = /^([A-Z_]+)\((.+)\)$/i;
  const funcMatch = processedExpr.match(funcPattern);
  if (funcMatch) {
    const [, funcName, argsString] = funcMatch;
    return evaluateFunctionCall(funcName, argsString, valueSource);
  }

  // Now check for comparison operators AFTER replacing headers
  const comparisonPattern = /^(.+?)(>=|<=|<>|!=|>|<|=)(.+)$/;
  const comparisonMatch = processedExpr.match(comparisonPattern);
  if (comparisonMatch) {
    const [, left, operator, right] = comparisonMatch;
    const stripQuotes = (s) => s.replace(/^(["'])(.*)\1$/, "$2");
    const leftTrimmed = stripQuotes(String(left).trim());
    const rightTrimmed = stripQuotes(String(right).trim());
    
    // Try to parse as numbers for numeric comparison
    const leftNum = leftTrimmed === "" ? NaN : Number(leftTrimmed);
    const rightNum = rightTrimmed === "" ? NaN : Number(rightTrimmed);
    const isNumericComparison = !isNaN(leftNum) && !isNaN(rightNum);
    
    const leftVal = isNumericComparison ? leftNum : leftTrimmed;
    const rightVal = isNumericComparison ? rightNum : rightTrimmed;
    
    switch (operator) {
      case ">":
        return leftVal > rightVal;
      case "<":
        return leftVal < rightVal;
      case ">=":
        return leftVal >= rightVal;
      case "<=":
        return leftVal <= rightVal;
      case "=":
        return leftVal === rightVal;
      case "<>":
      case "!=":
        return leftVal !== rightVal;
      default:
        return false;
    }
  }

  // Remove surrounding quotes for string literals
  if (
    (processedExpr.startsWith('"') && processedExpr.endsWith('"')) ||
    (processedExpr.startsWith("'") && processedExpr.endsWith("'"))
  ) {
    return processedExpr.slice(1, -1);
  }

  // If we replaced headers, return the processed value
  if (hasHeaders) {
    // Don't convert date-like strings to numbers
    if (isDateLike(processedExpr)) {
      return processedExpr;
    }
    // Try to parse as number if it looks like one
    const num = parseFloat(processedExpr);
    return isNaN(num) ? processedExpr : num;
  }

  // Don't convert date-like strings to numbers
  if (isDateLike(processedExpr)) {
    return processedExpr;
  }

  // Try to parse as number
  const num = parseFloat(processedExpr);
  if (!isNaN(num)) {
    return num;
  }

  return processedExpr;
};

// Evaluate a simple formula with sample values
// Formula format: =[Header1]+[Header2] or =FUNCTION([Header])
// @param formula - the formula string starting with =
// @param externalValues - optional object with header values from first_row data
// @param context - optional { fileName, sheetName } used by FILENAME and SHEETNAME
export const evaluateFormula = (formula, externalValues = null, context = {}) => {
  if (!formula || !formula.startsWith("=")) {
    return null;
  }

  // Merge external values with SAMPLE_VALUES (external takes priority)
  const valueSource = externalValues 
    ? { ...SAMPLE_VALUES, ...externalValues } 
    : SAMPLE_VALUES;

  try {
    const expression = formula
      .substring(1)
      .trim() // Remove leading =
      // FILENAME / SHEETNAME (with or without ()) become literals; [bracketed headers] are left alone
      .replace(/\[[^\]]+\]|\b(FILENAME|SHEETNAME)\b(?:\s*\(\s*\))?/gi, (m, name) => {
        if (!name) return m;
        const value = name.toUpperCase() === "FILENAME" ? context?.fileName : context?.sheetName;
        return `"${String(value ?? "").replace(/"/g, "'")}"`;
      });

    // First, replace all header references with actual values before evaluating
    const headerPattern = /\[([^\]]+)\]/g;
    let processedExpression = expression;
    let match;
    const replacements = [];

    // Collect all header references first
    while ((match = headerPattern.exec(expression)) !== null) {
      const header = match[1];
      const value = valueSource[header];
      if (value !== undefined && value !== null && value !== "") {
        replacements.push({ original: `[${header}]`, replacement: value });
      } else {
        replacements.push({ original: `[${header}]`, replacement: 0 });
      }
    }

    // Apply all replacements
    replacements.forEach(({ original, replacement }) => {
      processedExpression = processedExpression.split(original).join(
        typeof replacement === 'string' && (replacement.trim() === '' || isNaN(Number(replacement)))
          ? `"${replacement}"`
          : replacement
      );
    });

    // Check if it's a function call
    const funcPattern = /^([A-Z_]+)\((.+)\)$/i;
    const funcMatch = processedExpression.match(funcPattern);
    if (funcMatch) {
      const result = evaluateExpression(processedExpression, valueSource);
      return result;
    }

    // Safely evaluate basic math expressions
    if (/^[\d\s+\-*/().]+$/.test(processedExpression)) {
      const result = Function(`"use strict"; return (${processedExpression})`)();
      return typeof result === "number" ? result.toFixed(2) : null;
    }

    // Return the processed expression if it's not pure math
    return processedExpression.replace(/"/g, '');
  } catch (e) {
    console.error("Formula evaluation error:", e);
    return `Error: ${e.message}`;
  }
};

const isQuotedText = (value) => /^(["'])[\s\S]*\1$/.test(value);
const isNumericLiteral = (value) => /^-?\d+(\.\d+)?$/.test(value);
// Header references, nested functions and expressions are valid unquoted
const isReferenceOrExpression = (value) => /[\[(]/.test(value);

const splitTopLevelArguments = (text) => {
  const args = [];
  let current = "";
  let depth = 0;
  let quote = "";

  for (const char of text) {
    if (quote) {
      if (char === quote) quote = "";
    } else if (char === '"' || char === "'") {
      quote = char;
    } else if (char === "(") {
      depth += 1;
    } else if (char === ")") {
      depth -= 1;
    } else if (char === "," && depth === 0) {
      args.push(current.trim());
      current = "";
      continue;
    }
    current += char;
  }

  args.push(current.trim());
  return args;
};

// TEXT(value, format): typed text and the format must be quoted. Incomplete calls are not validated.
export const validateTextFunctionQuotes = (formula) => {
  const source = String(formula || "");
  const callPattern = /(?<![A-Za-z0-9_])TEXT\s*\(/gi;
  let match;

  while ((match = callPattern.exec(source)) !== null) {
    let depth = 1;
    let quote = "";
    let end = -1;
    const argsStart = match.index + match[0].length;

    for (let i = argsStart; i < source.length; i += 1) {
      const char = source[i];
      if (quote) {
        if (char === quote) quote = "";
      } else if (char === '"' || char === "'") {
        quote = char;
      } else if (char === "(") {
        depth += 1;
      } else if (char === ")") {
        depth -= 1;
        if (depth === 0) {
          end = i;
          break;
        }
      }
    }

    if (end === -1) continue;

    const [value = "", format = ""] = splitTopLevelArguments(
      source.slice(argsStart, end),
    );

    if (
      value &&
      !isQuotedText(value) &&
      !isNumericLiteral(value) &&
      !isReferenceOrExpression(value)
    ) {
      return "Invalid formula: Enter the TEXT() value in quotes, e.g. 'abc', or use a [Header]";
    }

    if (format && !isQuotedText(format) && !isReferenceOrExpression(format)) {
      return "Invalid formula: Enter the TEXT() format in quotes, e.g. 'YYYY-MM-DD'";
    }
  }

  return null;
};

// Dummy data for AI Anomalies Summaries
export const AI_ANOMALIES_DATA = [
  {
    id: 1,
    fieldName: "JE Number",
    description: "Document No. data should not be blank.",
    currentValue: "Document No.",
    aiSuggestedValue: "Internal ID",
    fileName: "JE_p1_2025.xlsx",
    fileId: 1,
    columnId: "jeNumber",
  },
  {
    id: 2,
    fieldName: "Account No.",
    description:
      "No client field mapped to Account. This is a mandatory header – confirm mapping will be blocked.",
    currentValue: "---",
    aiSuggestedValue: "GL Account No.",
    fileName: "JE_p1_2025.xlsx",
    fileId: 1,
    columnId: "glAccountNumber",
  },
  {
    id: 3,
    fieldName: "Account No.",
    description:
      "Account number formats differ: one file has 7 digits, the other has 10",
    currentValue: "---",
    aiSuggestedValue: "GL Account No.",
    fileName: "JE_p1_2025.xlsx",
    fileId: 1,
    columnId: "glAccountNumber",
  },
  {
    id: 4,
    fieldName: "Effective Date",
    description: "Found blanks in Posting Date column.",
    currentValue: "Posting Date",
    aiSuggestedValue: "Trans. Date",
    fileName: "JE_p2_2025.xlsx",
    fileId: 2,
    columnId: "effectiveDate",
  },
  {
    id: 5,
    fieldName: "Business Unit",
    description: "BU column found in one file and not in others.",
    currentValue: "---",
    aiSuggestedValue: "Business Unit",
    fileName: "JE_p2_2025.xlsx",
    fileId: 2,
    columnId: "businessUnit",
  },
  {
    id: 6,
    fieldName: "Functional Amount",
    description: "Debit and Credit amounts should be combined using a formula.",
    currentValue: "---",
    aiSuggestedValue: "=[Debit Amount]-[Credit Amount]",
    fileName: "JE_p1_2025.xlsx",
    fileId: 1,
    columnId: "functionalAmount",
  },
];

// Get AI anomalies for a specific file type
export const getAIAnomaliesForFileType = (fileType) => {
  // For now, return all anomalies. Later can filter by file type
  return AI_ANOMALIES_DATA;
};

export default {
  SAMPLE_CLIENT_HEADERS,
  SAMPLE_VALUES,
  // DUMMY_FILES_DATA,
  getSampleValue,
  getAvailableHeaders,
  // getDummyFilesForType,
  evaluateFormula,
  AI_ANOMALIES_DATA,
  getAIAnomaliesForFileType,
};
